import React from 'react';
import { Link } from 'react-router-dom';
export function Footer() {
  return <footer className="w-full bg-cream py-14" data-id="element-44" data-mp="3gf96f0gd6eb2">
      <div className="mx-auto flex max-w-[1400px] flex-col items-center gap-6 px-6 text-center md:px-10" data-id="element-45" data-mp="3gg0xbxz0nnv0">
        <Link to="/" className="font-display text-lg tracking-ultra text-ink" data-id="element-46" data-mp="32pfg0dp7nlz8">
          PARṆA
        </Link>
        <p className="text-[10px] font-light uppercase tracking-wider2 text-muted/70" data-id="element-47" data-mp="36ppjnjpj60ax">
          © {new Date().getFullYear()} PARṆA · Breathe well
        </p>
      </div>
    </footer>;
}